import {useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";

// Context
import {VideoPlayerSettingsContext} from "../../../../../Context/VideoPlayerSettingsContext";

// Models
import VideoDTO from "../../../../../Models/DTOs/VideoDTO";

// Hooks
import useFetchVideo from "../../../../../Hooks/Content/Watch/VideoFeed/useFetchVideoById";
import useFetchVideoPeakInfo from "../../../../../Hooks/Content/Watch/VideoSingle/useFetchVideoPeakInfo";

// Components
import VideoPlayer from "../../../../../Components/Layouts/Content/Watch/VideoSingle/VideoPlayer/VideoPlayer";
import VideoPrimaryInformation from "../../../../../Components/Layouts/Content/Watch/VideoSingle/VideoPrimaryInformation";
import ButtonPill from "../../../../../Components/Buttons/ButtonPill";

// Constants
import {RoutePaths} from "../../../../../Constants/RoutePaths";
import {UserAuthenticationContext} from "../../../../../Context/UserAuthenticationContext";

const TrailerFilm = () => {
    const

        // Parse the URL param into a number.
        {id} = useParams<string>(),
        videoId = id ? parseInt(id) : undefined,

        // Theatre mode forces the player to fill the width of the browser
        { isTheatreMode, setIsTheatreMode } = useContext(VideoPlayerSettingsContext),
        { userData, doesAuthTokenExist } = useContext(UserAuthenticationContext),

        // Video object
        [videoData, setVideoData] = useState<VideoDTO>({} as VideoDTO),

        // Hooks
        {video} = useFetchVideo(videoId, "GB"),
        {peak, updatePeak} = useFetchVideoPeakInfo(videoData.Id);

    useEffect(() => {
        if (video) {
            if (videoData.Id === undefined || video.Id !== videoData.Id) {
                setVideoData(video);
            }
        }
    }, [video]);

    return (
        <div className="page--watch-video page--watch-trailer">
            <div className={`page__wrapper ${isTheatreMode ? 'is-theatre-mode' : 'is-not-theatre-mode'}`}>
                <VideoPlayer
                    key={videoData.Id}
                    video={videoData}
                    autoPlay={true}
                    playbackAllowed={true}
                    isTheatreMode={isTheatreMode}
                    setIsTheatreMode={setIsTheatreMode}
                    peak={peak}
                    updatePeak={updatePeak}
                    isCommentInputFocused={false}
                    useTrailerLink={true}
                />

                <div className="watch__column watch__column-info">
                    <VideoPrimaryInformation
                        video={videoData}
                        isVideoLoading={videoData.Id === undefined}
                        disableRating={true}
                        disableDescription={true}
                        disableDateAndEpisodeInfo={true}
                        isTrailer={true}
                        doesAuthTokenExist={doesAuthTokenExist()}
                    />
                </div>

                {videoId && (
                    <div className="watch__button">
                        <ButtonPill
                            label="Watch Full Film"
                            link={RoutePaths.Watch(videoId)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default TrailerFilm;
